import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHistory = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10 1.6665C14.6025 1.6665 18.3334 5.39734 18.3334 9.99984C18.3334 14.6023 14.6025 18.3332 10 18.3332C5.39752 18.3332 1.66669 14.6023 1.66669 9.99984H3.33335C3.33335 13.6815 6.31835 16.6665 10 16.6665C13.6817 16.6665 16.6667 13.6815 16.6667 9.99984C16.6667 6.31817 13.6817 3.33317 10 3.33317C7.70835 3.33317 5.68669 4.489 4.48752 6.24984H6.66669V7.9165H1.66669V2.9165H3.33335V4.99984C4.85335 2.97484 7.27419 1.6665 10 1.6665ZM10.8334 5.83317V9.654L13.5359 12.3565L12.3567 13.5357L9.16669 10.344V5.83317H10.8334Z",
		fill: "#4B1DF4"
	})
});
export default SvgHistory;
